// @core/api/endpoints/billing/update_billing_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BillingPolicyResponse,
  UpdateBillingPolicyRequest,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update billing policy
 * Updates an existing billing policy.
 */
export async function UpdateBillingPolicy(
  policy_id: string,
  data: UpdateBillingPolicyRequest,
  options?: RequestOptions
): Promise<BillingPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<BillingPolicyResponse>(requestPath, data, requestOptions);
}
